/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; //  Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {
  $('.collection-size-chart').click(function () {
    $('.title-and-sort').css('z-index', '0');
    $('.kolom-list-product').css('position', 'relative');
    $('.kolom-list-product').css('z-index', '-1');
  })
  $('.close-size-chart-collection').click(function () {
    $('.title-and-sort').css('z-index', '');
    $('.kolom-list-product').css('position', '');
    $('.kolom-list-product').css('z-index', '');
  })
  // $(".ProductForm__Variants input").on("change", function () {
  //   var intatc = setInterval(() => {
  //     var vall = $(".ProductForm__AddToCart").html();
  //     if (vall != "Sold Out") {
  //       $(".ProductForm__AddToCart").html("Add To Cart")
  //     }
  //     else {
  //       clearInterval(intatc)
  //     }

  //     if ($(".ProductForm__AddToCart").html() == "Select") {
  //       clearInterval(intatc)
  //     }

  //   }, 0);
  // })

  if ($('.ProductForm__AddToCart').length) {
    $('.ProductForm__AddToCart').click(function () {
      // $(this).removeClass('Button--primary');
      // $(this).addClass('Button--primary-gray');
    });
  }

  // var intfloating = setInterval(() => {
  //   jQuery.getJSON('/cart.js', function (cart) {
  //     var item = cart.items;
  //     if (item.length) {
  //       $(".floating-order").addClass("floating-active");
  //     }
  //     else {
  //       $(".floating-order").removeClass("floating-active");
  //     }
  //   });
  // }, 1000);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  $(document).on("submit", "[action='/cart']", function (e) {
    e.preventDefault();
    // var produkna = "";
    // jQuery.ajaxSetup({
    //   async: false
    // });
    // jQuery.getJSON('/cart.js', function (cart) {
    //   $("form[action='/cart'] .Cart__Checkout").html("Please Wait...").attr("disabled")
    //   var item = cart.items;
    //   for (let index = 0; index < item.length; index++) {
    //     var variantOption = item[index].variant_options ?? ""
    //     var product_title = item[index].product_title
    //     var gender = ""
    //     jQuery.getJSON(`/products/${item[index].handle}.js`, function(product) {
    //       product['tags'].forEach(function(pr){
    //         if(pr.includes("gender-")){
    //           gender = pr.split("-")[1];
    //           gender = gender.charAt(0).toUpperCase() + gender.slice(1)
    //         }
    //       })
    //     })

    //     var product_d = `- ${product_title} ${gender} - ${item[index].variant_options[1]} (quantity: ${item[index].quantity})`
    //     produkna += `${product_d}%0A`;
    //   }
    //   produkna = capitalizeFirstLetter(produkna);
    //   // console.log(produkna);
    //   var pesan = `https://api.whatsapp.com/send?phone=6282289999707&text=My product selection(s): %0A${produkna}%0APlease check for product availability`;
    //   pesan = pesan.replace(/ /g, "%20");

    //   window.location.assign(pesan);
    //   return false;
    // });

    localStorage.setItem("back_to_product", location.href)
    location.href = `https://${Shopify.shop}/pages/checkout`
    return false;
  })

  if($('.discover-container').length){
    $('.discover-container').owlCarousel({
      items: 4,
      margin: 10,
      loop: true,
      responsive: {
        0: {
          items: 2
        },
        640: {
          items: 2
        },
        1140: {
          items: 4
        }
      }
    })
  }

  var quick_order = $('.quick-add')
  for (let i = 0; i < quick_order.length; i++) {
    console.log(i);
    $('.quick-open-for-' + i).click(function (event) {
      $('.quick-open-for-' + i + ' .quick-open').hide();
      $('.quick-open-for-' + i + ' .form-submit').show();
    })
    document.querySelectorAll(".quick-open-for-" + i + " .ColorSwatch__Radio").forEach(item => {
      item.addEventListener("change", () => {
        $('.add-to-cart-for-' + i).attr('data-var_id', item.value)
        $('.add-to-cart-for-' + i).attr('data-add-to-cart', item.value)
      })
    })
    $('.add-to-cart-for-' + i).click(function () {
      console.log('click for index ' + i);
      var swatchId = $(this).attr('data-var_id');
      swatchAddItemToCart(swatchId, 1);
    })
    function swatchAddItemToCart(variantId, Qty) {
      data = {
        "id": variantId,
        "quantity": Qty
      }
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (data) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          console.log('success: ', data)
          setTimeout(() => {
            $('a[data-drawer-id="sidebar-cart"]').trigger('click');
            $('#sidebar-cart').attr('aria-hidden', false);
            $('#sidebar-cart').attr('tabindex', "-1");
            $('.PageOverlay').addClass('is-visible')
          }, 500);
          setTimeout(() => {
            $('button[data-drawer-id="sidebar-cart"]').trigger('click');
            $('#sidebar-cart').attr('aria-hidden', true);
            $('#sidebar-cart').removeAttr('tabindex')
            $('.PageOverlay').removeClass('is-visible')
          }, 3000);
        }
      });
    }
  }


  var cek_variant_qty = $('select[name=id]').find(":selected").attr('disabled');
  console.log(cek_variant_qty);
  if (cek_variant_qty !== undefined) {
    $('#bdd-notify').css('display', 'block');
  }
  number_format = function (number, decimals, dec_point, thousands_sep) {
    number = number.toFixed(decimals);

    var nstr = number.toString();
    nstr += "";
    x = nstr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? dec_point + x[1] : "";
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1)) x1 = x1.replace(rgx, "$1" + thousands_sep + "$2");

    return x1 + x2;
  };

  var heighestElement = function (passname) {
    var maxHeight = 0;
    jQuery(passname).each(function () {
      if (jQuery(this).height() > maxHeight) { maxHeight = jQuery(this).height(); }
      // console.log(maxHeight)
    });

    jQuery(passname).height(maxHeight);
    // console.log(maxHeight)
  }

  let lastScroll = 0;
  let headerHeight = $('#shopify-section-header').outerHeight();
  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    var window_height = jQuery(window).height();

    // console.log(currentScroll);
    // if (currentScroll < 200) {
    //   jQuery('.filter-custom').addClass('mh-unset');
    // }
    // else {
    //   jQuery('.filter-custom').removeClass('mh-unset');
    // }

    if (currentScroll > lastScroll) {
      if (currentScroll > headerHeight) {
        $('#shopify-section-header').addClass('down')
        $('#shopify-section-header').removeClass('up')

        if ($('.custom-filter-sec').length > 0) {
          var heightTambah = jQuery('.title-and-sort').outerHeight();
          var maxHeightna = window_height - heightTambah;
          jQuery('.filter-custom').css('top', heightTambah + 'px');
          jQuery('.filter-custom').css('max-height', maxHeightna + 'px');
        }
      }
    } else if (currentScroll < lastScroll) {
      $('#shopify-section-header').removeClass('down')
      $('#shopify-section-header').addClass('up')

      if ($('.custom-filter-sec').length > 0) {
        var heightTambah = jQuery('#shopify-section-header').outerHeight();
        var maxHeightna = window_height - heightTambah;
        jQuery('.filter-custom').css('top', heightTambah + 'px');
        jQuery('.filter-custom').css('max-height', maxHeightna + 'px');
      }
    }
    lastScroll = currentScroll;
  })

  $('div[data-block-handle="platmart-product-colors"]').prependTo('.color-swatches')

  if($('.slider-collection').length){
    $('.slider-collection').owlCarousel({
      loop: true,
      responsiveClass: true,
      nav: true,
      navText: [
        "<div class='nav-btn prev-slide'></div>",
        "<div class='nav-btn next-slide'></div>",
      ],
      margin: 0,
      autoplayTimeout: 4000,
      smartSpeed: 400,
      center: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 3
        },
        1200: {
          items: 3
        }
      }
    });
  }

  // if ($('.slider-cl').length > 0) {
  //   $('.slider-cl').flickity({
  //     pageDots: false,
  //     wrapAround: true,
  //     cellAlign: 'center',
  //     adaptiveHeight: true,
  //     imagesLoaded: true
  //   });

  //   var intCl = setInterval(() => {
  //     if ($('.slider-cl').outerHeight() > 0) {
  //       $('.slider-cl').prepend(`
  //         <style>
  //           .item-swipe img{
  //             max-width: 80%;
  //             transition: .5s ease;
  //           }
  //         </style>
  //       `);
  //       heighestElement('.slider-cl .item-swipe');

  //       // jQuery('.slider-cl .next').click(function(){
  //       //   jQuery('.item-swipe .innerItem').removeClass('text-left')
  //       //   jQuery('.item-swipe.is-selected .innerItem').addClass('text-left')
  //       // })

  //       // jQuery('.slider-cl .previous').click(function(){
  //       //   jQuery('.item-swipe .innerItem').removeClass('text-right')
  //       //   jQuery('.item-swipe.is-selected .innerItem').addClass('text-right')
  //       // })

  //       clearInterval(intCl);
  //     }
  //   }, 500);

  //   var intLastItem = setInterval(() => {
  //     if ($('.item-swipe:last-child').hasClass("is-selected")) {
  //       $('.item-swipe:first-child .innerItem').addClass('text-left')
  //     }
  //     else {
  //       $('.item-swipe:first-child .innerItem').removeClass('text-left')
  //     }
  //   }, 1);
  // }

  if ($('.custom-filter-sec').length > 0) {
    jQuery(".filter-group-display").hide();
    jQuery(".filter-group[open] .filter-group-display").show();
    jQuery(".filter-group-summary").click(function () {
      var parentFilter = jQuery(this).parent();
      if (parentFilter.attr("open")) {
        jQuery(this).parent().find(".filter-group-display").hide(400);
        parentFilter.removeAttr("open");
      } else {
        jQuery(this).parent().find(".filter-group-display").show(400);
        parentFilter.attr("open", "");
      }
    });

    jQuery('.filter-group-display__list-item input[type=checkbox]').change(function () {
      var action = jQuery(this).attr('click-action')
      console.log(jQuery(this).val())
      jQuery('[click-action=' + action + ']input:checkbox').not(this).prop('checked', false);
      jQuery(".filter-form").submit();
    })

    jQuery('.item-active').click(function () {
      var action = jQuery(this).attr('click-action').replace(' ', '_')
      console.log(action)
      jQuery('.filter-group-display__list-item input[type=checkbox][data-value=' + action + ']').click();
    })

    jQuery('.sort-mobile .filter-group-display__list-item input[type=radio]').change(function () {
      var action = jQuery(this).val()
      const urlSearchParams = new URLSearchParams(
        window.location.search
      );

      urlSearchParams.set('sort_by', action);
      window.location = `?${urlSearchParams}`;
    })
  }
  // if (jQuery(".flat-slider").length > 0) {
  //   let maxRange = parseInt(
  //     jQuery(".filter-group-display__price-range-to input").attr("max")
  //   );

  //   let currentMin = jQuery(
  //     ".filter-group-display__price-range-from input"
  //   ).val();
  //   let currentMax = jQuery(
  //     ".filter-group-display__price-range-to input"
  //   ).val();

  //   // console.log(maxRange, currentMin, currentMax)

  //   // console.log(number_format(maxRange, 0, ',', '.') + ' - ' + currentMin + ' - ' +  currentMax)

  //   jQuery("#flat-slider").slider({
  //     orientation: "horizontal",
  //     range: true,
  //     animate: true,
  //     min: 0,
  //     max: Number(maxRange),
  //     values: [Number(currentMin), Number(currentMax)],
  //     slide: function (event, ui) {
  //       if (ui.values[1] - ui.values[0] < 1) {
  //         return false;
  //       }

  //       // console.log(ui.values[0] + ' - ' + ui.values[1])

  //       jQuery(".filter-group-display__price-range-from input").val(
  //         ui.values[0]
  //       );
  //       jQuery(".filter-group-display__price-range-to input").val(
  //         ui.values[1]
  //       );

  //       var minFormat = number_format(ui.values[0], 0, ",", ".");
  //       var maxFormat = number_format(ui.values[1], 0, ",", ".");

  //       jQuery(".flex-price-range .min-price").html("IDR " + minFormat);
  //       jQuery(".flex-price-range .max-price").html("IDR " + maxFormat);
  //     },
  //   });
  // }

  if (jQuery("#SortBy").length > 0) {
    document
      .querySelector("#SortBy")
      .addEventListener("change", function () {
        const urlSearchParams = new URLSearchParams(
          window.location.search
        );

        urlSearchParams.set(this.name, this.value);

        window.location = `?${urlSearchParams}`;
      });
  }

  jQuery('.filter-trig-mobile, .close-filter').click(function () {
    jQuery('.kolom-filter').toggleClass('active');
    jQuery('body').toggleClass('overflow-none');
  })
  // Get the modal
  var modal = document.getElementById("modal-wishlist");
  var modal2 = document.getElementById("modal-wishlist2");

  // Get the button that opens the modal
  var btn = document.getElementById("popup-wishlist");
  var btn2 = document.getElementById("popup-wishlist2");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("popup-close")[0];
  var span2 = document.getElementsByClassName("popup-close2")[0];

  // When the user clicks the button, open the modal 
  // btn.onclick = function () {
  //   modal.style.display = "block";
  //   $('body').css('overflow', 'hidden');
  //   $('#shopify-section-header').addClass('shopify-section-header-overlay')
  // }
  // btn2.onclick = function () {
  //   modal2.style.display = "block";
  //   $('body').css('overflow', 'hidden');
  //   $('#shopify-section-header').addClass('shopify-section-header-overlay')
  // }

  // When the user clicks on <span> (x), close the modal
  // span.onclick = function () {
  //   modal.style.display = "none";
  //   $('body').css('overflow', 'auto');
  //   $('#shopify-section-header').removeClass('shopify-section-header-overlay')

  // }
  // span2.onclick = function () {
  //   modal2.style.display = "none";
  //   $('body').css('overflow', 'auto');
  //   $('#shopify-section-header').removeClass('shopify-section-header-overlay')
  // }
  // function footer accordion
  var acc = document.getElementsByClassName("footer-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("footer-active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
  // announcement bar slider

  if($('.announcement-slick').length){
    $('.announcement-slick').owlCarousel({
      items: 1,
      nav: true,
      loop: true,
      navText: [
        "<div class='nav-btn prev-slide'><i class='fa fa-arrow-left fa-lg'></i></div>",
        "<div class='nav-btn next-slide'><i class='fa fa-arrow-right fa-lg'></i></div>",
      ],
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: false,
      dots: false
    })
  }

  var acc = document.getElementsByClassName("filter-button");
  var i;

  // $(document).on("click", ".filter-button", function(){
  //   $(this).toggleClass("filter-active");
  //   let panel = $(this).next()
  //   if (panel.style.maxHeight) {
  //     panel.style.maxHeight = null;
  //   } else {
  //     panel.style.maxHeight = "210" + "px";
  //   }
  // })

  // for (i = 0; i < acc.length; i++) {
  //   acc[i].addEventListener("click", function () {
  //     this.classList.toggle("filter-active");
  //     var panel = this.nextElementSibling;
      // if (panel.style.maxHeight) {
      //   panel.style.maxHeight = null;
      // } else {
      //   panel.style.maxHeight = "210" + "px";
      // }
  //   });
  // }

  if($(".highlight-product-wrapper").length){
    $('.highlight-product-wrapper').owlCarousel({
      items: 4,
      margin: 15,
      nav: true,
      loop: true,
      navText: [
        "<div class='nav-btn prev-slide'><i class='fa fa-chevron-left fa-lg'></i></div>",
        "<div class='nav-btn next-slide'><i class='fa fa-chevron-right fa-lg'></i></div>",
      ],
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: false,
      dots: false,
      responsive: {
        0: {
          items: 2
        },
        600: {
          items: 2
        },
        1000: {
          items: 4
        }
      }
    })
  }

  /************************** button "add to cart" collection pages **************************/

  // $('.ad_to_cart_coll').click(function () {
  //   var ID = $(this).attr("data-var_id");
  //   addItemToCart(ID, 1);    // paste your id product number
  //   $('.cart_dr').trigger("click");
  //   // alert("Added to cart");
  // });


  // function addItemToCart(variant_id, qty) {
  //   data = {
  //     "id": variant_id,
  //     "quantity": qty
  //   }
  //   jQuery.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: data,
  //     dataType: 'json',
  //     success: function () {

  //       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  //         bubbles: true
  //       }));

  //       $('#sidebar-cart').attr('aria-hidden', 'false');
  //       $('.PageOverlay').addClass('is-visible');
  //       $('#sidebar-cart .Drawer__Close').click(function () {
  //         $('#sidebar-cart').attr('aria-hidden', 'true');
  //         $('.PageOverlay').removeClass('is-visible');
  //       })

  //     }

  //   });

  // }

  // document.querySelectorAll(".ColorSwatch__Radio-js").forEach(item => {
  //   item.addEventListener("change", () => {
  //     $('.swatch--add-to-cart').attr('data-var_id', item.value)
  //     $('.swatch--add-to-cart').attr('data-add-to-cart', item.value)
  //   })
  // })

  // $('.swatch--add-to-cart').click(function () {
  //   var swatch_id = $(this).attr("data-var_id");
  //   swatchAddItemToCart(swatch_id, 1);    // paste your id product number
  //   $('.cart_dr').trigger("click");
  //   // alert("Added to cart");
  // });

  // function swatchAddItemToCart(variant_id, qty) {
  //   data = {
  //     "id": variant_id,
  //     "quantity": qty
  //   }
  //   jQuery.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: data,
  //     dataType: 'json',
  //     success: function () {

  //       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  //         bubbles: true
  //       }));

  //       $('#sidebar-cart').attr('aria-hidden', 'false');
  //       $('.PageOverlay').addClass('is-visible');
  //       $('#sidebar-cart .Drawer__Close').click(function () {
  //         $('#sidebar-cart').attr('aria-hidden', 'true');
  //         $('.PageOverlay').removeClass('is-visible');
  //       })

  //     }

  //   });

  // }

  $(document).on("click", ".quick-view--item", function(e){
    // e.preventDefault();
    let product_handle = $(this).attr("data-product")
    let collection_handle = $(this).attr("data-collection")

    sessionStorage.setItem('scrollElement', product_handle);

    if(collection_handle != ""){
      sessionStorage.setItem('collectionElement', collection_handle);
    }
  })

  $(".backto-collection").click(function(){
    // history.back();
    var current_link = localStorage.getItem("search_current_collectoin")
    var link = $(".backto-collection").attr("href")
    if(current_link != ""){
      if(!location.href.includes("collections")){
        var arrLink = location.href.split("products")
        link = `${arrLink[0]}collections/${current_link}`
        localStorage.removeItem('search_current_collectoin')

        let sessElement = sessionStorage.getItem('scrollElement');
        if (sessElement !== null) {
          sessionStorage.removeItem('scrollElement');
        }
      }
    }
    
    location.href = link
    return false;
  })

  var selection = document.querySelector('#SortBy') !== null;
  if (selection) {
    document.querySelector('#SortBy').addEventListener('change', function () {
      const urlSearchParams = new URLSearchParams(window.location.search);
  
      urlSearchParams.set(this.name, this.value);
  
      window.location = `?${urlSearchParams}`;
    });
  }
  
})